import React from "react";
import style from "../woundAssessment.module.scss";
import { Modal } from "../../../secondary";
import { Button } from "../../../primary";

export const PdfDownloadDialog = ({ historyId, onClose, onWithImages, onWithoutImages }) => (
  <Modal modalOpen={() => {}} modalClose={onClose} modalSize={style.custom_modal_size_pdf}>
    <div className={style.modalparent}>
      <div className={`${style.modal_heading_pdf} pb-2`}>
        <div className={`${style.modal_header_pdf} pl-3 pt-3`}>
          <h3>PDF Download</h3>
        </div>
        <button type="button" className={`close ${style.close_icon_pdf} pr-3`} onClick={onClose}>
          &times;
        </button>
      </div>

      <div className={`${style.modal_footer}`}>
        <div className={"px-4 mt-5"}>
          <h2>
            {" "}
            Do you want to include <br /> wound images?{" "}
          </h2>
        </div>
        <div className={"d-flex justify-content-center px-3 pt-5 pb-2"}>
          <Button
            type="submit"
            value="Yes"
            classes={{ className: `btn btn-small ml-0 mr-5 ${style.btn_small} ${style.btn_custom}` }}
            id="save"
            onClick={() => onWithImages(historyId)}
          />
          <Button
            type="button"
            value="No"
            classes={{ className: `btn btn-small ${style.btn_small_cancel} ${style.btn_custom} ml-4` }}
            id="cancel"
            onClick={() => onWithoutImages(historyId)}
          />
        </div>
      </div>

      <br />
    </div>
  </Modal>
);
